import { Navigate, Route, Routes } from 'react-router-dom'
import { SectionTabs } from '@/components/SectionTabs'
import { JoinWorkspace } from './JoinWorkspace'
import { WorkspaceDetailPage } from './WorkspaceDetailPage'
import { WorkspaceOverview } from './WorkspaceOverview'

export function SharedWorkspaces() {
  return (
    <Routes>
      <Route
        index
        element={
          <>
            <SectionTabs />
            <WorkspaceOverview />
          </>
        }
      />
      <Route path="join" element={<JoinWorkspace />} />
      <Route path=":workspaceId" element={<WorkspaceDetailPage />} />
      <Route path="*" element={<Navigate to="/projects" replace />} />
    </Routes>
  )
}
